<hrm-spinner></hrm-spinner>
<router-outlet></router-outlet>

<ng-progress></ng-progress>